import axios from "axios";

const store = {
  state: {},

  getters: {},

  mutations: {},

  actions: {
    storeEventAction(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/events/store`, payload)
          .then((res) => {
            resolve(res.data.event);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    updateEventAction(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/events/update/${payload.id}`, payload)
          .then((res) => {
            resolve(res.data.event);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    deleteEventAction(Context, evenId) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/events/delete/${evenId}`)
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    findEventsAction() {
      return new Promise((resolve, reject) => {
        axios
          .post(`/events/find`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    findEventByDateAction(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/events/find-by-date`, payload)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};

export default store;
